@use "assets/styles/abstracts/variables" as v;
@use "assets/styles/abstracts/mixins/typography" as t;

.contactInfo {
    padding: 32px;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 30px;
}

.contactInfoText {
    color: v.$palette-gray-500;
    @include t.text(16px, 26px, normal);
}

.contactInfoLogoWrapper {
    position: relative;
    margin-top: auto;
}

.contactInfoLogo {
    position: absolute;
    top: -27px;
    width: 60px;
    right: 0;
}